import React, { useEffect, useState } from "react";
import Select from "react-select";
import { BankData } from "../../data/BankData";
import ButtonRequire from "../../components/Button/ButtonRequire";
import _ from "lodash";
import { requestGet } from "../../api/coreInstance";
import FormInput from "../../components/Input/FormInput";
import CardSection from "../../components/Card/CardSection";
import { useTranslation } from "react-i18next";

export default function BankDetailsFragment({
  setFragment,
  addOnUser,
  dataAccount,
  token,
}) {
  const { t } = useTranslation();
  const [inputBank, setInputBank] = useState({});
  const [optionsData] = useState({
    banks: BankData.map((bank) => ({
      ...bank,
      label: bank.bankName,
      value: bank.channel_code,
    })),
  });
  useEffect(() => {
    GetData();
    return () => {
      setInputBank({});
    };
  }, []);

  //   TODO: SESUAIKAN RESPONSE API
  async function GetData(isReturn) {
    try {
      // Get data bank details
      let bank = await requestGet(`/bank-account`, {
        params: { retailer: dataAccount.id },
        headers: { Authorization: `Bearer ${token}` },
      });
      if (bank.data.data[0]) {
        bank = bank.data.data[0];
      }

      if (isReturn) {
        return bank;
      } else {
        setInputBank((prevState) => ({
          ...prevState,
          bank_account_id: bank.bank_account_id,
          bankName: bank.bankName,
          accountNumber: bank.accountNumber,
          name: bank.name,
        }));
      }
    } catch (error) {
      console.error(error);
    }
  }

  return (
    <div className="mt-4 space-y-3">
      <CardSection title={t("profile.bankAcc")}>
        <div className="space-y-2">
          <div className="flex justify-between text-xs">
            <p className="text-monochrome-300">Nama Bank</p>
            <p className="text-monochrome-400">{inputBank?.bankName ?? "-"}</p>
          </div>
          <div className="flex justify-between text-xs">
            <p className="text-monochrome-300">Nomor Rekening</p>
            <p className="text-monochrome-400">
              {inputBank?.accountNumber ?? "-"}
            </p>
          </div>
          <div className="flex justify-between text-xs">
            <p className="text-monochrome-300">Nama Pemilik Rekening</p>
            <p className="text-end text-monochrome-400">
              {inputBank?.name ?? "-"}
            </p>
          </div>
        </div>
      </CardSection>
    </div>
  );
}
